import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
	lerNavegarQueryAtual,
	navegarPorPush,
	registrarBridgeNavegarPagina,
} from '../servicos/config/navegarNotificacao.js'

/**
 * Cobre redirecionamento por push no React (sem alterar Android/iOS):
 * - ?navegar= na URL (cold start / reload, igual cotação)
 * - window.navegarPagina(chave) (fallback iOS viewDidAppear)
 */
export default function useRedirecionamentoPush() {
	const navigate = useNavigate()
	const location = useLocation()

	useEffect(() => {
		registrarBridgeNavegarPagina(navigate)
		return () => {
			try {
				delete window.navegarPagina
			} catch {
				window.navegarPagina = undefined
			}
		}
	}, [navigate])

	useEffect(() => {
		const chave = lerNavegarQueryAtual()
		if (!chave) return
		// Cold start: Inicial.jsx valida token e aplica validarRedirecionamento
		if (location.pathname === '/' || location.pathname === '') return
		navegarPorPush(navigate, chave)
	}, [location.search, location.pathname, navigate])
}
